/**
 * Get registry
 * @module actions/registry
 */

import { GET_REGISTRY } from '../../constants/ActionTypes';

/**
 * Get registry.
 * @function GetRegistry
 * @returns {Object} Get registry.
 */
export function getRegistry(registry_key) {
  return {
    type: GET_REGISTRY,
    registry_key: registry_key,
    request: {
      op: 'get',
      path: `/@anon-registry/${registry_key}`,
    },
  };
}